import { z } from 'zod/v3';
import {
  ActionResult,
  ApplicableContext,
  BaseAction,
  ExecuteContext,
} from '../../../v0/actions/framework';
import { CoteraAbilities } from '@cotera/api';
import { DevModeModel } from './dev-mode.model';
import { ok } from 'neverthrow';

type Params = {};

export class DisableDevModeAction extends BaseAction<Params, { t: string }[]> {
  title = 'Disable Dev Mode';
  inputSchema = z.object({});
  group = 'Developer Tools';
  icon = 'code-bracket';

  constructor(private readonly abilities: CoteraAbilities) {
    super();
  }

  applicable(context: ApplicableContext): boolean {
    return (
      this.abilities.can(['use', 'devserver']) &&
      context.isInScope(DevModeModel) &&
      context.getInScopeModelOfType(DevModeModel)!.enabled.snapshot()
    );
  }

  async execute(
    _: Params,
    context: ExecuteContext
  ): Promise<ActionResult<{ t: string }[]>> {
    const model = context.getInScopeModelOfType(DevModeModel)!;
    model.disable();
    return ok({});
  }
}
